'use strict';exports.__esModule = true;exports.default =













multiLanguageTags;var _startsWith = require('lodash/startsWith');var _startsWith2 = _interopRequireDefault(_startsWith);var _constants = require('../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var removeLocalePrefix = function removeLocalePrefix(route) {var ret = route.substring(1);_constants.languages.forEach(function (_ref) {var value = _ref.value;if ((0, _startsWith2.default)(route, '/' + value + '/')) {ret = route.split('/' + value + '/')[1];}});return ret;};function multiLanguageTags(route, locale) {
  return _constants.languages.
  filter(function (lang) {return lang.value !== locale;}).
  map(function (_ref2) {var value = _ref2.value;
    var partRoute = removeLocalePrefix(route);
    var link = {
      rel: 'alternate',
      hrefLang: value,
      href: _constants.shareUrl + '/' + value + '/' + partRoute };

    if (value === _constants.language.default) {
      link.href = partRoute === '' ? _constants.shareUrl : _constants.shareUrl + '/' + partRoute;
    }

    return link;
  });
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/multiLanguageHeadTags.js
// module id = 63
// module chunks = 0